import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionLabel } from '../SectionLabel';
import { CtaButton } from '../CtaButton';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <section className="border-b border-white/10 bg-ink-900" data-id="element-82" data-mp="1cm7owa9hjte3">
      <div className="mx-auto w-full max-w-xl px-4 py-12 sm:py-16 lg:max-w-6xl" data-id="element-83" data-mp="18jkqtrm81c8g">
        <div className="text-center" data-id="element-84" data-mp="18hrkyejfmw1i">
          <SectionLabel data-id="element-85" data-mp="25a3ktcr8dh9t">🎁 100% gratis oggi</SectionLabel>
          <h2 className="mt-4 font-display text-[26px] uppercase leading-[1.1] text-white sm:text-3xl lg:text-[40px]" data-id="element-86" data-mp="257hdne8953s4">
            Oggi riceverai anche questi <span className="text-accent" data-id="element-87" data-mp="1w8dr209vm68v">5 sistemi premium</span>
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-[15px] leading-relaxed text-white/65 sm:text-base" data-id="element-88" data-mp="1ralqkhv61bt2">
            Organizzare un’attività non dipende solo dall’avere documenti: dipende dall’avere i
            sistemi giusti. Questi bonus ti aiutano a implementarlo molto più velocemente.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 lg:grid-cols-2 lg:gap-5" data-id="element-89" data-mp="1eteuu6aizo6u">
          {bonuses.map(bonus => <li key={bonus.title} className="flex flex-col rounded-2xl border border-white/10 bg-ink-800 p-5 sm:p-6" data-id="element-90" data-mp="1jrovuxixlj0d">
              <figure className="-mx-1 mb-5 overflow-hidden rounded-xl border border-white/10 bg-ink-900" data-id="element-91" data-mp="1as1pdxbchn0g">
                <img src={bonus.image} alt={bonus.imageAlt} className="mx-auto block w-full max-w-[420px]" width={1250} height={1250} loading="lazy" data-id="element-92" data-mp="w3fc015a35bv" />
              </figure>

              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-accent" data-id="element-93" data-mp="r3szxv16rv4n">
                {bonus.index}
              </span>
              <h3 className="mt-2.5 font-display text-lg uppercase leading-tight text-white sm:text-xl" data-id="element-94" data-mp="d4tboohl5i90">
                <span aria-hidden="true" data-id="element-95" data-mp="i2uvxcqqznm2">{bonus.emoji}</span> {bonus.title}
              </h3>
              <p className="mt-3 text-[14px] leading-relaxed text-white/60 sm:text-[15px]" data-id="element-96" data-mp="2ju4qq901j2gs">
                {bonus.description}
              </p>

              <ul className="mt-4 space-y-2" data-id="element-97" data-mp="2b09nj6ihbm3s">
                {bonus.includes.map(item => <li key={item} className="flex items-start gap-2" data-id="element-98" data-mp="2615fij7ajuf1">
                    <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-accent" aria-hidden="true" data-id="element-99" data-mp="262zw5lbj50db" />
                    <span className="text-[13.5px] leading-snug text-white/75 sm:text-sm" data-id="element-100" data-mp="2yqvueugqz0c7">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-auto flex items-center justify-between gap-3 border-t border-white/10 pt-4 sm:pt-5" data-id="element-101" data-mp="2oqv7kyjo6239">
                <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-white/35" data-id="element-102" data-mp="1icvxlsd77qt6">
                  Valore commerciale
                </span>
                <span className="flex items-baseline gap-2" data-id="element-103" data-mp="139ccbdftu1gv">
                  <span className="text-sm font-semibold text-white/35 line-through" data-id="element-104" data-mp="136q4dcp0xjy4">
                    {bonus.value}
                  </span>
                  <span className="rounded-md bg-accent px-2 py-0.5 font-display text-xs uppercase tracking-wide text-ink-950" data-id="element-105" data-mp="1d5pez0tcnpnr">
                    Gratis
                  </span>
                </span>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-md lg:max-w-lg" data-id="element-106" data-mp="1qy59tec3khdl">
          <CtaButton label="Voglio i 5 bonus gratis" data-id="element-107" data-mp="1qwkiryozrgkh" />
        </div>
      </div>
    </section>;
}